// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WO-z","isFullWidth":"XO-z","landingPageVideo":"YO-z","play":"ZO-z","iframeVideo":"_O-z","playHidden":"aP-z","fullwidth":"bP-z"};